<template>
  <div>
    <modal name="dashboard-login-modal" classes="modal" :minWidth="200" Connections :minHeight="400" :maxWidth="480"
      :scrollable="true" :reset="true" :height="'auto'" :adaptive="true" width="90%" @closed="onCloseModal">

      <div class="flex justify-end relative">
        <button @click="$modal.hide('dashboard-login-modal')" class="absolute right-0 mr-4 mt-4">
          <img src="@/assets/times-black.svg" alt="">
        </button>
      </div>

      <h2 class="text-center my-4" style="font-size: 24px">GİRİŞ YAP</h2>

      <div class="text-center my-4" style="font-size: 24px">
        <button type="button" @click="useEmail = true" :class="{ 'active': useEmail }">
          <img src="@/assets/icon-email.svg" alt="Login with E-Mail" />
        </button>
        <button type="button" @click="useEmail = false" :class="{ 'active': !useEmail }">
          <img src="@/assets/icon-phone.svg" alt="Login with Cep Telefonu" />
        </button>
        <button type="button" @click="onClickFacebook">
          <img class="img-svg" src="@/assets/facebook-2.svg" alt="Login with facebook" />
        </button>
        <button type="button" @click="onClickGoogle">
          <img class="img-svg" src="@/assets/google-2.svg" alt="Login with google" />
        </button>
      </div>
      <h2 class="text-center my-4" style="font-size: 24px">OYNAMAYA BAŞLA</h2>
      <div class="mx-auto flex flex-col items-center px-4">
        <p class="mb-4 text-center text-danger" v-html="this.errorMsg"></p>
        <form class="flex flex-col items-center w-full" @submit.prevent="registerAction">
          <validation-observer class="flex flex-col" style="width:80%" ref="form">
            <validation-provider v-if="useEmail" class="mb-4" tag="div" name="E-Mail Adresi" rules="required|email"
              v-slot="{ errors }">
              <input type="text" :disabled="loading" v-model="loginData.username" required name="username"
                class="form-special" placeholder="E-Mail Adresi">
              <div class="error-label">{{ errors[0] }}</div>
            </validation-provider>
            <validation-provider v-else class="mb-4" tag="div" name="Cep Telefonu"
              rules="required|validPhone|validatePhoneNumberLength" v-slot="{ errors }">
              <vue-tel-input type="tel" v-model="loginData.username" mode="international" :invalidMsg="errors[0]"
                :preferredCountries="['TR']" :validCharactersOnly="true" :disabled="loading" :autoFormat="true"
                :dropdownOptions="{
                  showDialCodeInList: true,
                  showFlags: true,
                  showSearchBox: true,
                }" :inputOptions="{
                  type: 'tel',
                  required: true,
                  name: 'username',
                  maxlength: 17,
                  placeholder: 'Cep Telefonu',
                }">
              </vue-tel-input>
              <div class="error-label">{{ errors[0] }}</div>
            </validation-provider>
            <validation-provider tag="div" name="Şifre" rules="required" v-slot="{ errors }">
              <input type="password" :disabled="loading" v-model="loginData.password" required name="password"
                class="form-special" placeholder="Parola">
              <div class="error-label">{{ errors[0] }}</div>
            </validation-provider>
            <div class="text-right mb-4">
              <button type="button" class="mb-3 underline" @click="clickResetPassword()">Parolamı
                unuttum</button>
            </div>

            <div class="mb-5 center-content">
              <RecaptchaComponent :sitekey="siteKey" :callback="onCaptchaSuccess" />
            </div>

            <button type="submit" class="btn btn--primary block mb-5 mx-auto"
              v-bind:class="{ 'ld-over-inverse running': this.loading == true }" @click.prevent="loginAction">
              Giriş Yap
              <div class="ld ld-ring ld-spin" v-bind:class="{ 'running': this.loading == true }" v-if="loading"></div>
            </button>
          </validation-observer>
        </form>
      </div>
    </modal>

    <reset-password-modal :username="_.cloneDeep(loginData.username)"
      @handleReset="onRequestPasswordReset"></reset-password-modal>

    <phone-verification-modal ref="password-reset-modal" name="password-reset-modal" type="password"
      :username="this.loginData.username" title="Parolanı Sıfırla" description="Size iletilen kodu girin" />

    <phone-verification-modal ref="phone-otp-verification-modal" name="phone-otp-verification-modal" type="verify"
      title="Telefon numaranızı doğrulayın" description="Cep telefonunuza gönderilen kodu girin" />

  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ResetPasswordModal from './ResetPasswordModal';
import PhoneVerificationModal from "@/views/components/PhoneVerificationModal"
import RecaptchaComponent from './RecaptchaComponent.vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { isValidPhoneNumber, parsePhoneNumberFromString } from "libphonenumber-js";
import axios from 'axios';


extend('validPhone', {
  validate: (value) => isValidPhoneNumber(value, 'TR'),
  message: 'Lütfen geçerli bir telefon numarası giriniz.',
});
extend('validatePhoneNumberLength', {
  validate: (value) => {
    const phoneNumber = parsePhoneNumberFromString(value, 'TR');
    return phoneNumber && phoneNumber.nationalNumber.length === 10;
  },
  message: 'Telefon numarası 10 haneli olmalıdır.',
});

export default {
  components: {
    ResetPasswordModal,
    PhoneVerificationModal,
    ValidationProvider,
    ValidationObserver,
    RecaptchaComponent,
  },
  name: "dashboard-login-modal",
  data() {
    return {
      loginData: {
        username: null,
        password: null
      },
      errorMsg: "",
      loading: false,
      useEmail: true,
      siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      secretKey: process.env.VUE_APP_RECAPTCHA_SECRET_KEY,
      isCaptchaValidated: false,
    }
  },
  computed: {
    ...mapState(["player"]),
  },
  methods: {
    ...mapActions(['login', 'facebookLogin', 'googleLogin', 'createConfirmationRequest']),
    async onCaptchaSuccess(token) {
      try {
        const response = await axios.post('https://www.google.com/recaptcha/api/siteverify', null, {
          params: {
            secret: this.secretKey,
            response: token,
          }
        });
        if (response.data.success) {
          this.isCaptchaValidated = true;
        } else {
          console.error('Token verification failed:', response);
        }
      } catch (error) {
        console.error('Error verifying reCAPTCHA token:', error);
      }
      this.isCaptchaValidated = true;
    },
    loginAction() {
      this.errorMsg = "";
      this.$refs.form.validate().then((isValid) => {
        if (!isValid) {
          return;
        } else if (!this.isCaptchaValidated) {
          this.$toast.error('Lütfen reCAPTCHA doğrulamasını tamamlayın.');
          return;
        }
        this.loading = true;
        this.login(this.loginData).then(response => {
          this.loading = false;
          this.$gtag.event('login', { userId: response.data.result.set.id, source: "loginEmail" });
          this.$OneSignal.setExternalUserId(this.player.id)
          this.$modal.hide("dashboard-login-modal");
          if (this.useEmail === false && !this.player.isVerifiedMsisdn) {
            this.openVerificationModal();
          }
        }).catch(error => {
          this.loading = false;
          this.$toast.error(error.response.data.message);
        });
      })
    },
    onClickFacebook() {
      if (this.player.isFacebook) {
        this.$toast.warning('Hesabınız daha önce bağlandı');
        return false;
      }
      this.$fAuth.logInWithFacebook().then(response => {
        if (response.status === 'connected') {
          this.facebookLogin({
            token: response.authResponse.accessToken,
            userID: response.authResponse.userID
          }).then(() => {
            this.$modal.hide("dashboard-login-modal");
          }).catch(error => {
            if (error.response && error.response.data && error.response.data.code == "401.0011") {
              this.$modal.show("error-modal", { content: error.response.data && error.response.data.message ? error.response.data.message : "Bilinmeyen bir hata oluştu. Hata tekrar ederse destek ekibimizle iletişime geçebilirsiniz.", issue: "support" });
            }
          });
        }
      });
    },
    onClickGoogle() {
      if (this.player.isGoogle) {
        this.$toast.warning('Hesabınız daha önce bağlandı');
        return false;
      }
      this.$gAuth
        .signIn()
        .then(GoogleUser => {
          this.googleLogin({
            "token": GoogleUser.getAuthResponse().id_token,
            "access": GoogleUser.getAuthResponse().access_token
          }).then(() => {
            this.$modal.hide("dashboard-login-modal");
          }).catch(error => {
            if (error.response && error.response.data && error.response.data.code == "401.0011") {
              this.$modal.show("error-modal", { content: error.response.data && error.response.data.message ? error.response.data.message : "Bilinmeyen bir hata oluştu. Hata tekrar ederse destek ekibimizle iletişime geçebilirsiniz.", issue: "support" });
            }
          });
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    onRequestPasswordReset(e) {
      this.loginData.username = e.username
      this.$modal.hide('reset-password-modal')
      this.$modal.show('password-reset-modal')
    },
    openVerificationModal() {
      this.createConfirmationRequest({ id: this.player.id, type: 'verify' }).then((response) => {
        if (response.data.code === "200.0401") {
          this.loading = false;
          this.$toast.error(response.data.message);
          return;
        }
        this.loading = false;
        this.handleClearInput()
        this.$toast.success('Kod Cep telefonunuza gönderildi');
      }).catch(() => {
        this.loading = false;
        this.$toast.error('Bir problem oluştu lütfen daha sonra tekrar deneyin');
      })
      this.$modal.hide("dashboard-login-modal");
      this.$modal.show("phone-otp-verification-modal");
    },
    clickResetPassword() {
      this.$modal.show('reset-password-modal')
      this.$modal.hide("dashboard-login-modal")
    },
    handleClearInput() {
      this.$refs.otpInput.clearInput()
      if (this.$refs.form) {
        this.$refs.form.reset();
        this.password = null;
        this.passwordConfirm = null;
      }
    },
    onCloseModal() {
      this.loginData = {
        username: null,
        password: null
      };
      this.isCaptchaValidated = false;
    }
  }
}
</script>

<style scoped>
.active {
  font-weight: bold;
}

button.active img {
  border: 2px solid #ffb74f;
  border-radius: 50%;
}

.vue-tel-input {
  border-radius: 8px;
  display: flex;
  border: 4px solid black;
  text-align: left;
}

.center-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>